import script from "./OrderStatusInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderStatusInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./OrderStatusInfoCard.vue?vue&type=style&index=0&id=2a42e4e7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a42e4e7"]])

export default __exports__